import React from 'react';
import classNames from 'classnames';
import EventListener from 'react-event-listener';

import Image from './Image';
import Unavailable from './Unavailable';

const MapImage = ({url, loading, onUnload, ...props}) => {
    const Child = url ? Image : Unavailable;

    return (
        <div id="projection-map-image">
            <div className={classNames('image', {loading})}>
                <EventListener target={window} onBeforeUnload={onUnload} onUnload={onUnload}>
                    <Child {...props} url={url} />
                </EventListener>
            </div>
        </div>
    );
};

export default MapImage;
